import React, { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { Product } from '../../types';

interface UnifiedAnalyticsConfig {
	productSwitcher?: Product | string;
	unifiedInstrumentationEnabled?: boolean;
}

interface UnifiedAnalyticsContextProviderProps {
	children: ReactNode;
	productSwitcher?: Product | string;
	unifiedInstrumentationEnabled?: boolean;
}

const UnifiedAnalyticsContext = createContext<UnifiedAnalyticsConfig | undefined>(undefined);

export const UnifiedAnalyticsContextProvider = ({
	unifiedInstrumentationEnabled,
	productSwitcher,
	children,
}: UnifiedAnalyticsContextProviderProps) => {
	const contextValue = useMemo<UnifiedAnalyticsConfig>(
		() => ({
			unifiedInstrumentationEnabled,
			productSwitcher,
		}),
		[productSwitcher, unifiedInstrumentationEnabled],
	);

	return (
		<UnifiedAnalyticsContext.Provider value={contextValue}>
			{children}
		</UnifiedAnalyticsContext.Provider>
	);
};

export const useUnifiedAnalyticsContext = (): UnifiedAnalyticsConfig => {
	const context = useContext(UnifiedAnalyticsContext);

	return (
		context ?? {
			unifiedInstrumentationEnabled: false,
			productSwitcher: 'appSwitcher',
		}
	);
};
